import { PortalPjBreadcrumbs, PortalPjSupertopo } from '@/components/PortalPj/PortalPjSupertopo'
import { useFixedLightRoute } from '@/hooks/useFixedLightRoute'

type Props = {
  children: React.ReactNode
}

/** Layout público do cadastro PJ — sem sessão CRM (link externo). */
export function PjCadastroPublicLayout({ children }: Props) {
  useFixedLightRoute('portal-pj-route')

  return (
    <div className='portal-pj-page flex min-h-screen flex-col bg-[#0d0221] font-sans text-white'>
      <PortalPjSupertopo variant='public' />

      <main className='mx-auto w-full max-w-3xl flex-1 px-4 pb-8 pt-6 sm:px-6 sm:pt-8'>
        <PortalPjBreadcrumbs className='mb-5 text-white/60' currentLabel='Cadastro PJ' />
        {children}
      </main>

      <footer className='border-t border-white/10 bg-[#080116] py-4 text-center text-xs text-white/50'>
        Cadastro seguro · RocketSearch
      </footer>
    </div>
  )
}
